module.exports = __webpack_public_path__ + "img/2.cd7c91ed.png";